import { combineReducers } from "@reduxjs/toolkit"
import bookingReducer from "./bookingReducer"
import toastifyReducer from "./toastifyReducer"
import multipleBookingReducer from "./multipleBookingReducer"
import offerReducer from "./offerReducer"
import serviceReducer from "./serviceReducer"

const rootReducer = combineReducers({
  bookingReducer,
  toastifyReducer,
  multipleBookingReducer,
  offerReducer,
  serviceReducer
})
export default rootReducer
